import { PrivateAPINamespace } from '../PrivateAPINamespace';
export class InfoNamespace extends PrivateAPINamespace {
    getMetaSiteId() {
        return this.ps.ds.generalInfo.getMetaSiteId();
    }
    getUser() {
        return this.ps.ds.generalInfo.getUserInfo().userId;
    }
    getEditorSessionId() {
        return this.ps.hostAPI.editor.info.getEditorSessionId();
    }
    getAppInstance(appDefinitionId) {
        return this.ps.ds.platform.getAppDataByAppDefId(appDefinitionId)?.instance;
    }
    getLanguageCode() {
        return this.ps.ds.generalInfo.getLanguage();
    }
    getViewMode() {
        return this.ps.ds.viewMode.get();
    }
    getEditorType() {
        // @ts-expect-error
        return window?.commonConfig?.brand;
    }
    getSiteDirection() {
        return this.ps.ds.accessibility.getSiteDirection();
    }
    siteHasCustomClasses() {
        const MASTER_PAGE_ID = 'masterPage';
        const CUSTOM_CSS_APP_ID = '081cfa21-cdf6-4f50-9a1b-0f3722acfd8b';
        return this.ps.ds.platform.pageHasPlatformApp(MASTER_PAGE_ID, CUSTOM_CSS_APP_ID);
    }
    getThemeCustomProperties(filter) {
        const ds = this.ps.ds;
        const filterKeys = filter?.keys?.map((key) => {
            if (key.startsWith('--')) {
                return key.slice(2);
            }
            return key;
        });
        // The 'list' api currently returns all variables.
        // It would be helpful if DM could provide a way to return only cssProperties variable types - but
        // they don't have that kind of filter and refuse to add it for some reason at this point..
        const variables = ds.global.variables
            .list({})
            .map((v) => ds.global.variables.get(v))
            .filter((v) => {
            if (typeof v.value.value !== 'string') {
                return false;
            }
            return filterKeys?.length && filterKeys.includes(v.cssVarName);
        });
        const out = {};
        // process variables one at a time, adding all children to the process list
        while (variables.length > 0) {
            const v = variables.shift();
            if (v === undefined) {
                break;
            }
            // add all child variables to the process list
            const withChildren = ds.global.variables.getChildVariables(v);
            variables.push(...Object.values(withChildren.children).map((c) => ds.global.variables.get(c.pointer)));
            if (out[v.cssVarName]) {
                continue;
            }
            if (v.cssVarName === undefined) {
                continue;
            }
            out[v.cssVarName] = {
                type: v.type,
                value: v.value.value,
                displayName: v.name || v.cssVarName,
            };
        }
        // make sure all of the keys in the filter are in the result object
        if (filter?.keys) {
            for (let key of filter.keys) {
                if (key.startsWith('--')) {
                    key = key.slice(2);
                }
                if (out[key]) {
                    continue;
                }
                out[key] = { error: 'key not found' };
            }
        }
        return out;
    }
}
InfoNamespace.namespace = 'info';
//# sourceMappingURL=InfoNamespace.js.map